import type { AdapterConfigFieldsProps } from "./types";

export function LocalWorkspaceRuntimeFields(_props: AdapterConfigFieldsProps) {
  return null;
}
